export default [
  {
    path: "/rep-dashboard",
    name: "rep-dashboard",
    component: () =>
      import("@/views/schoolRepDashboard/schoolRepdashboard.vue"),
    meta: {
      title: "REP DASHBOARD",
    },
  },

  {
    path: "/pin-purchase",
    name: "pin-purchase",
    component: () => import("@/views/pin-purchase/index.vue"),
    meta: {
      title: "PIN PURCHASE",
    },
  },
  {
    path: "/outstanding-payment/:id",
    name: "outstanding-payment",
    component: () => import("@/views/mySchool/components/outstanding.vue"),
    meta: {
      title: "OUTSTANDING",
    },
  },
 
  {
    path: "/view-pinPayment/:id",
    name: "view-pinPayment",
    component: () => import("@/views/mySchool/components/pin-payment.vue"),
    meta: {
      title: "PIN PAYMENT",
    },
  },
  {
    path: "/transaction",
    name: "transaction",
    component: () => import("@/views/transaction/transaction.vue"),
    meta: {
      title: "TRANSACTION",
    },
  },
  {
    path: "/checkout-page",
    name: "checkout-page",
    component: () => import("@/views/mySchool/components/checkout.vue"),
    meta: {
      title: "CHECKOUT",
    },
  },
  {
    path: "/pin-checkout",
    name: "pin-checkout",
    component: () => import("@/components/checkout.vue"),
    meta: {
      title: "CHECKOUT",
    },
  },
];
